<div class="agpr-qnA-page">
    @if (!hasData || (currentMonitor?.status === monitorStatus.paused)) {
        <div class="agpr-qnA-banner">
            <agpr-message [severity]="messageSeverities.info">
                {{ 'Vi.qnA.noData' | localize }}
            </agpr-message>
        </div>
    }
    <div
        class="agpr-qnA-section"
        [agprLoading]="loading"
    >
        <div class="agpr-qnA-sectionLeft">
            <div
                [id]="id + '_dateSelector'"
                class="agpr-qnA-dateSelector"
            >
                <agpr-vi-date-picker
                    [id]="id + '_startInput'"
                    class="agpr-dateRangeSelector-dateRange-datePicker"
                    [mostRecentDate]="mostRecentDate"
                    [availableDates]="dayOptions"
                    [ariaLabelledBy]="id + '_startDateLabel'"
                    [placeholder]="!hasData ? 'Vi.qnA.noAnswersAvailable' : ''"
                    [(ngModel)]="selectedDate"
                    (ngModelChange)="dateChanged()"
                    [disabled]="!hasData"
                ></agpr-vi-date-picker>
            </div>

            <agpr-scroll-panel>
                <div class="agpr-qnA-dimensionCard-list">
                    @for (card of dimensionCards; track card.dimension) {
                        <agpr-vi-dimension-card
                            [card]="card"
                            [selectedQuestion]="selectedQuestion"
                            [allowDelete]="false"
                            [interactive]="false"
                            (questionSelected)="focusQuestion($event)"
                        ></agpr-vi-dimension-card>
                    }
                </div>
            </agpr-scroll-panel>
        </div>

        @if (brand) {
            <div class="agpr-qnA-sectionRight">
                <agpr-right-sidebar
                    class="agpr-qnA-rhp"
                    [loading]="rhpLoading"
                >
                    <agpr-tab
                        [id]="id + '_answersTab'"
                        class="agpr-qnA-answersTab"
                        icon="fa-solid fa-message-lines"
                        tooltip="Vi.qnA.tab.answers"
                        heading="Vi.qnA.tab.answers"
                    >
                        <agpr-vi-answer-panel
                            [engines]="answerEngineOptions"
                            [(selectedType)]="selectedEngineType"
                        ></agpr-vi-answer-panel>
                    </agpr-tab>

                    <agpr-vi-insights-tab
                        [id]="id + '_insightsTab'"
                        class="agpr-qnA-insightsTab"
                        [initialViBrand]="brand"
                        [answerEngineTypes]="answerEngineOptions"
                        [prompts]="prompts"
                        [executedPrompt]="executedPrompt"
                        (langSelectionChanged)="selectedInsightsLanguage = $event"
                    ></agpr-vi-insights-tab>

                    <agpr-tab
                        [id]="id + '_answerScoresTab'"
                        class="agpr-qnA-answerScoresTab"
                        icon="fa-duotone fa-solid fa-bars-progress"
                        tooltip="Vi.qnA.tab.answerScore"
                        heading="Vi.qnA.tab.answerScore"
                    >
                        <agpr-vi-answer-scores
                            [id]="id + '_answerScores'"
                            [engines]="answerEngineOptions"
                            [previousEngines]="previousAnswerEngineOptions"
                            [ownDomains]="brand.websites ?? []"
                        ></agpr-vi-answer-scores>
                    </agpr-tab>

                    <agpr-vi-source-outlets-tab
                        [id]="id + '_sourceOutletsTab'"
                        class="agpr-qnA-sourceOutletsTab"
                        [outletList]="outletList"
                        [loading]="outletListLoading"
                    ></agpr-vi-source-outlets-tab>

                    <agpr-tab
                        [id]="id + '_monitorDetailsTab'"
                        class="agpr-qnA-monitorDetailsTab"
                        icon="fa-regular fa-file-lines fa-duotone"
                        tooltip="Vi.qnA.tab.monitorDetails"
                        header="Vi.qnA.tab.monitorDetails"
                        [showSpacer]="true"
                    >
                        <agpr-scroll-panel>
                            <agpr-attribute-list
                                [attributes]="attributes"
                            ></agpr-attribute-list>
                        </agpr-scroll-panel>
                    </agpr-tab>

                    <agpr-tab
                        [id]="id + '_monitorSourcesTab'"
                        class="agpr-qnA-monitorSourcesTab"
                        icon="fa-duotone fa-regular fa-table-tree"
                        tooltip="Vi.qnA.tab.monitorSources"
                        header="Vi.qnA.tab.monitorSources"
                    >
                        <agpr-scroll-panel>
                            <agpr-panel
                                [id]="id + '_monitorSourcesTab_brandDetailsPanel'"
                                class="agpr-qnA-monitorSourcesTab-panel"
                                header="Vi.qnA.monitorSourceTab.brandDetails"
                                [headingLevel]="5"
                            >
                                <agpr-vi-brand-identity-readonly-card
                                    [brand]="brand"
                                    [canToggle]="false"
                                ></agpr-vi-brand-identity-readonly-card>
                            </agpr-panel>
                            @if (currentMonitor.isCompetitiveBenchmarking) {
                                <agpr-panel
                                    [id]="id + '_monitorSourcesTab_competitorDetailsPanel'"
                                    class="agpr-qnA-monitorSourcesTab-panel"
                                    header="Vi.qnA.monitorSourceTab.competitorDetails"
                                    [headingLevel]="5"
                                >
                                    @for (competitor of competitors; track competitor) {
                                    <agpr-vi-brand-identity-readonly-card
                                            [brand]="competitor"
                                        ></agpr-vi-brand-identity-readonly-card>
                                    }
                                </agpr-panel>
                            }
                        </agpr-scroll-panel>
                    </agpr-tab>
                </agpr-right-sidebar>
            </div>
        }
    </div>
</div>
